'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = require("lodash");

var _datalist = _interopRequireDefault(require("../datalist"));

var _conf = _interopRequireDefault(require("../../conf"));

var _fetchUtils = _interopRequireDefault(require("../../fetchUtils"));

var _formInputField = _interopRequireDefault(require("../form-input-field"));

var _translate = _interopRequireDefault(require("../translate"));

var _uploadModal = _interopRequireDefault(require("../upload-modal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var programTypeList = [{
  id: 'programs',
  name: 'programs'
}, {
  id: 'productionlabels',
  name: 'productionlabels'
}];
var languageMapping = {
  1: 'de',
  2: 'fr',
  3: 'it'
};
var apiUrlSuffix = 'ApiUrlTemplate';
var imageRemoveApiUrlSuffix = "RemoveImage".concat(apiUrlSuffix);
var imageAddApiUrlSuffix = "AddImage".concat(apiUrlSuffix);

var ProgramList = /*#__PURE__*/function (_React$Component) {
  _inherits(ProgramList, _React$Component);

  function ProgramList(props) {
    var _this;

    _classCallCheck(this, ProgramList);

    _this = _possibleConstructorReturn(this, (ProgramList.__proto__ || Object.getPrototypeOf(ProgramList)).call(this, props));
    _this.state = {
      isLoading: false,
      programsNotFound: false,
      programs: [],
      filters: {
        programType: '',
        language: ''
      },
      editModalOpen: false,
      form: {
        error: null,
        invalidFields: {
          fields: [],
          details: {}
        }
      },
      programToBeEditedId: null,
      languageList: [],
      uploadUrl: ''
    };
    _this.onDropDownChange = _this.onDropDownChange.bind(_assertThisInitialized(_this));
    _this.showEditLink = _this.showEditLink.bind(_assertThisInitialized(_this));
    _this.resetEditMode = _this.resetEditMode.bind(_assertThisInitialized(_this));
    _this.openEditModal = _this.openEditModal.bind(_assertThisInitialized(_this));
    _this.closeEditModal = _this.closeEditModal.bind(_assertThisInitialized(_this));
    _this.getImagePreviewOutput = _this.getImagePreviewOutput.bind(_assertThisInitialized(_this));
    _this.getFilteredLanguage = _this.getFilteredLanguage.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ProgramList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.load();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          t = _this$props.t,
          i18n = _this$props.i18n;

      if (!i18n.isInitialized) {
        return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
          className: "loader loader--medium"
        }));
      }

      var columns = [{
        title: t('edit'),
        render: this.showEditLink
      }, {
        title: t('program name'),
        prop: 'name'
      }, {
        title: t('program type'),
        prop: 'type'
      }, {
        title: t('image'),
        render: this.getImagePreviewOutput
      }];
      var staticTexts = {
        search: t('search'),
        noData: t('no data'),
        loading: t('loading data'),
        all: t('all'),
        pageSize: t('results per page')
      };
      var translatedProgramTypeList = programTypeList.map(function (programType) {
        return {
          id: programType.id,
          name: t(programType.name)
        };
      });

      var table = /*#__PURE__*/_react.default.createElement("div", {
        className: "program-list-comp"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 medium-4"
      }, /*#__PURE__*/_react.default.createElement(_formInputField.default, {
        isEditable: true,
        name: 'programType',
        label: t('program type'),
        onChange: this.onDropDownChange,
        type: _formInputField.default.component.constants.SINGLE_SELECT,
        list: translatedProgramTypeList,
        value: this.state.filters.programType,
        allowAll: true
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 medium-4"
      }, /*#__PURE__*/_react.default.createElement(_formInputField.default, {
        isEditable: true,
        name: 'language',
        label: t('language'),
        onChange: this.onDropDownChange,
        type: _formInputField.default.component.constants.SINGLE_SELECT,
        list: this.state.languageList,
        value: this.state.filters.language,
        allowAll: false
      }))), /*#__PURE__*/_react.default.createElement(_datalist.default, {
        keys: ['id', 'project_key'],
        columns: columns,
        initialData: this.state.programs,
        initialPageLength: 10,
        staticTexts: staticTexts,
        isLoading: this.state.isLoading,
        initialSortBy: {
          prop: 'name',
          order: 'ascending'
        }
      }), /*#__PURE__*/_react.default.createElement(_uploadModal.default, {
        name: "image",
        postUrl: this.state.uploadUrl,
        isOpen: this.state.editModalOpen,
        onUploadSuccess: function onUploadSuccess(response) {
          _this2.setState(function (prev) {
            prev.programs[prev.programToBeEditedId].image = response[0];
            return prev;
          }, _this2.closeEditModal);
        },
        onUploadError: function onUploadError(err) {
          _this2.closeEditModal();

          void 0;
        },
        closeHandler: function closeHandler(e) {
          e.preventDefault();

          _this2.closeEditModal();
        }
      }));

      if (this.state.programsNotFound) table = /*#__PURE__*/_react.default.createElement("p", null, t('no program registrations'));
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h1", null, t('program overview')), table);
    }
  }, {
    key: "getImagePreviewOutput",
    value: function getImagePreviewOutput(val, row) {
      var _this3 = this;

      var t = this.props.t;
      var file = row.image || {};
      var preview = t('No image found');

      if (!(0, _lodash.isEmpty)(file)) {
        preview = /*#__PURE__*/_react.default.createElement("div", {
          className: "file-card"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "file-card__header"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "preview-image"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "preview-image__img"
        }, /*#__PURE__*/_react.default.createElement("picture", null, /*#__PURE__*/_react.default.createElement("source", {
          srcSet: "/file/".concat(file.id, "/large"),
          media: "(min-width: 1024px)"
        }), /*#__PURE__*/_react.default.createElement("source", {
          srcSet: "/file/".concat(file.id, "/medium"),
          media: "(min-width: 700px)"
        }), /*#__PURE__*/_react.default.createElement("img", {
          style: {
            position: 'absolute'
          },
          alt: file.file_name,
          srcSet: "/file/".concat(file.id, "/small")
        }))))), /*#__PURE__*/_react.default.createElement("div", {
          className: "file-card__footer"
        }, !file.is_fallback && /*#__PURE__*/_react.default.createElement("ul", {
          className: "file-actions"
        }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("button", {
          onClick: function onClick(e) {
            return _this3.deleteImage(e, row.id);
          },
          className: "file-action"
        }, /*#__PURE__*/_react.default.createElement("i", {
          className: "icon icon-delete"
        }))))));
      }

      return preview;
    }
  }, {
    key: "deleteImage",
    value: function deleteImage(e, programIdInRow) {
      var _this4 = this;

      e.stopPropagation();
      var programToBeEdited = this.state.programs[programIdInRow] || {};

      if (!(0, _lodash.isEmpty)(programToBeEdited)) {
        var identifier = programToBeEdited.identifier,
            elementId = programToBeEdited.elementId,
            image = programToBeEdited.image;
        var language = this.getFilteredLanguage();
        var apiUrlName = identifier + imageRemoveApiUrlSuffix;

        var url = _conf.default.api[apiUrlName](language, elementId, image.id);

        return fetch(url, {
          credentials: 'include',
          method: 'DELETE'
        }).then(_fetchUtils.default.checkStatus).then(function () {
          _this4.setState(function (prev) {
            delete prev.programs[programIdInRow].image;
            return prev;
          });

          _this4.resetEditMode();

          _this4.load();
        }).catch(function (err) {
          void 0;

          _this4.resetEditMode();

          _this4.load();
        });
      }

      this.resetEditMode();
      var error = new Error('No program selected');
      return Promise.reject(error);
    }
  }, {
    key: "getFilteredLanguage",
    value: function getFilteredLanguage() {
      return this.state.filters.language || 'de';
    }
  }, {
    key: "openEditModal",
    value: function openEditModal(programIdInRow) {
      var programToBeEdited = this.state.programs[programIdInRow] || {};

      if (!(0, _lodash.isEmpty)(programToBeEdited)) {
        var identifier = programToBeEdited.identifier,
            elementId = programToBeEdited.elementId;
        var language = this.getFilteredLanguage();
        var apiUrlName = identifier + imageAddApiUrlSuffix;
        this.setState(function (prev) {
          prev.editModalOpen = true;
          prev.uploadUrl = _conf.default.api[apiUrlName](language, elementId);
          prev.programToBeEditedId = programToBeEdited.id;
          return prev;
        });
      }
    }
  }, {
    key: "closeEditModal",
    value: function closeEditModal() {
      this.setState({
        editModalOpen: false
      });
      this.resetEditMode();
    }
  }, {
    key: "resetEditMode",
    value: function resetEditMode() {
      this.setState(function (prev) {
        prev.form.error = null;
        prev.form.invalidFields = {
          fields: [],
          details: {}
        };
        prev.programToBeEditedId = null;
        prev.uploadUrl = '';
        return prev;
      });
    }
  }, {
    key: "showEditLink",
    value: function showEditLink(val, row) {
      var _this5 = this;

      var t = this.props.t;

      if (row.image && !row.image.is_fallback) {
        return '';
      }

      return /*#__PURE__*/_react.default.createElement("button", {
        style: {
          margin: '0 auto'
        },
        className: "btn btn--icon edit-link",
        onClick: function onClick() {
          return _this5.openEditModal(row.id);
        },
        title: t('edit')
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon icon-edit"
      }));
    }
  }, {
    key: "getFilteredPrograms",
    value: function getFilteredPrograms(filter) {
      var result = programTypeList.find(function (programTypeObject) {
        return filter === programTypeObject.id;
      });

      if (result) {
        return [result];
      }

      return programTypeList;
    }
  }, {
    key: "load",
    value: function load() {
      var _this6 = this;

      var t = this.props.t;
      var filteredPrograms = this.getFilteredPrograms(this.state.filters.programType);
      this.setState(function (prev) {
        prev.programs = [];
        return prev;
      });
      var counter = 0;
      var language = this.getFilteredLanguage();
      filteredPrograms.map(function (programTypeObject) {
        var programUrlName = programTypeObject.id + apiUrlSuffix;
        var programUrl = _conf.default.api[programUrlName](language) + '?withImage=true';
        fetch(programUrl, {
          credentials: 'include'
        }).then(_fetchUtils.default.checkStatus).then(function (programs) {
          _this6.setState(function (prev) {
            prev.programs = prev.programs.concat(programs.map(function (program) {
              program.type = t(programTypeObject.name);
              program.elementId = program.id;
              program.id = counter++;
              program.identifier = programTypeObject.id;
              return program;
            }));
            return prev;
          });
        }).catch(function () {
          _this6.setState(function (prev) {
            prev.projectsNotFound = true;
            prev.isLoading = false;
            return prev;
          });
        });
      });
      fetch(_conf.default.api.correspondenceLanguageApiUrlTemplate(this.props.i18n.language)).then(_fetchUtils.default.checkStatus).then(function (result) {
        _this6.setState(function (prev) {
          prev.languageList = result.slice(0, 3).map(function (language) {
            language.elementId = language.id;
            language.id = languageMapping[language.elementId];
            return language;
          });
          return prev;
        });
      });
    }
  }, {
    key: "onDropDownChange",
    value: function onDropDownChange(event) {
      var target = event.target;
      var name = target.name;
      return this.setState(function (prevState) {
        prevState.filters[name] = target.value || '';
        return prevState;
      }, this.load);
    }
  }]);

  return ProgramList;
}(_react.default.Component);

ProgramList.propTypes = {
  t: _propTypes.default.func.isRequired,
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string,
    isInitialized: _propTypes.default.bool
  })
};

var _default = (0, _translate.default)(ProgramList);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/program-list/index.js
// module id = 728
// module chunks = 0